export const dataToSelect = (data, [valueField, labelField]) => {
  if (!data) {
    return [];
  }

  return data
    .filter(
      (item) =>
        Object.prototype.hasOwnProperty.call(item, valueField) &&
        item[valueField] &&
        Object.prototype.hasOwnProperty.call(item, labelField) &&
        item[labelField],
    )
    .map((item) => ({
      value: item[valueField],
      label: item[labelField],
    }));
};
